/** Rotate original bytes, so the enlarged preview and the eventual upload agree. */
export async function rotatePickedInvoicePage(file: File, pageNumber: number): Promise<File> {
  if (!Number.isInteger(pageNumber) || pageNumber < 1) throw new RangeError('Invalid original page');
  if (file.type === 'application/pdf' || /\.pdf$/i.test(file.name)) {
    const { PDFDocument, degrees } = await import('pdf-lib');
    const pdf = await PDFDocument.load(await file.arrayBuffer());
    if (pageNumber > pdf.getPageCount()) throw new RangeError('Invalid original page');
    const page = pdf.getPage(pageNumber - 1);
    page.setRotation(degrees((page.getRotation().angle + 90) % 360));
    return new File([new Uint8Array(await pdf.save())], file.name, { type: 'application/pdf', lastModified: file.lastModified });
  }
  if (pageNumber !== 1) throw new RangeError('Invalid original page');
  const image = await createImageBitmap(file);
  try {
    const canvas = document.createElement('canvas');
    canvas.width = image.height;
    canvas.height = image.width;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Canvas unavailable');
    context.translate(canvas.width, 0);
    context.rotate(Math.PI / 2);
    context.drawImage(image, 0, 0);
    const type = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
    const bytes = await new Promise<Blob>((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Image unavailable')), type, 0.94));
    return new File([bytes], file.name, { type, lastModified: file.lastModified });
  } finally {
    image.close();
  }
}
